<script setup lang="ts">
defineProps<{ email: string }>()
</script>
<template>
  <div
    class="fixed right-0 bottom-0 z-50 flex items-center justify-center rounded-tl bg-zinc-800 p-2 text-xs text-green-500 shadow-xl"
  >
    <div class="mr-2 size-2 animate-pulse rounded-full bg-green-600" />
    <span class="mr-1 italic">IM session: {{ email }}</span>
  </div>
</template>
